import React, { useState, useEffect } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import { Link } from "react-router-dom";
import { TablePagination, Tooltip } from "@mui/material";
import dayjs from "dayjs";
import { baseURL } from "../../../util/Config";
import noImage from "../../../assets/images/noImage.png";
import { getComplain, solvedComplain } from "../../../store/complain/action";
import { OPEN_COMPLAIN_DIALOG } from "../../../store/complain/types";
import ComplainDetails from "../../dialog/ComplainDetails";

const TablePaginationActions = React.lazy(() => import("../TablePagination"));

const ComplainRequest = (props) => {
  const dispatch = useDispatch();
  

  const [type, setType] = useState(() => {
    return localStorage.getItem('complainRequestTab') || "Pending"
  });
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleTabChange = (newType) => {
    setType(newType);
    localStorage.setItem('complainRequestTab', newType);
  };

  useEffect(() => {
    dispatch(getComplain(type.toLowerCase()));
  }, [dispatch, type]);

  const complain = useSelector((state) => state.complain.complain);

  useEffect(() => {
    setData(complain);
  }, [complain]);

  // ... rest of the handlers (handleChangePage, handleChangeRowsPerPage, handleSearch, etc.)

  const handleSolvedComplain = (id) => {
    
    props.solvedComplain(id);
  };

  const handleViewComplainDetail = (data) => {
    dispatch({ type: OPEN_COMPLAIN_DIALOG, payload: data });
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-white">Complain Request</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">Complain Request</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="my-2">
            <button
              type="button"
              className={`btn btn-sm ${type === "Pending" ? "btn-info" : "disabledBtn"}`}
              onClick={() => handleTabChange("Pending")}
            >
              <span className="">Pending</span>
            </button>
            <button
              type="button"
              className={`btn btn-sm ${type === "Solved" ? "btn-danger" : "disabledBtn"} ms-3`}
              onClick={() => handleTabChange("Solved")}
            >
              <span className="">Solved</span>
            </button>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="card">
        {/* ... search bar section ... */}
        <div className="card-body card-overflow">
          <table className="table table-striped">
            <thead className="text-center">
              <tr>
                <th>No.</th>
                <th>User</th>
                <th>Complain Image</th>
                <th>Contact</th>
                <th>{type === "Pending" ? "CreatedAt" : "Solved date"}</th>
                {type === "Pending" && <th>Solved</th>}
                <th>Details</th>
              </tr>
            </thead>
            <tbody className="text-center">
            {data.length > 0 ? (
                    (rowsPerPage > 0
                      ? data.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : data
                    ).map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{data.userId?.name}</td>
                          <td>
                            <img
                              height="50px"
                              width="50px"
                              alt="app"
                              src={data.image ? baseURL + data.image : noImage}
                              style={{
                                boxShadow: "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                border: "2px solid #fff",
                                borderRadius: 10,
                                objectFit: "cover",
                                display: "block",
                              }}
                              className="mx-auto"
                            />
                          </td>

                          <td>{data.contact}</td>
                          <td>
                            {dayjs(data.updatedAt).format("DD MMM, YYYY")}
                          </td>

                          <td>
                            <Tooltip title="Complain Details">
                              <button
                                type="button"
                                className="btn btn-sm btn-info"
                                onClick={() => handleViewComplainDetail(data)}
                              >
                                <i className="fas fa-info-circle fa-lg"></i>
                              </button>
                            </Tooltip>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="10" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
            </tbody>
          </table>
          {/* ... pagination ... */}
        </div>
      </div>
      <ComplainDetails />
    </>
  );
};

export default connect(null, { getComplain, solvedComplain })(ComplainRequest); 